import {
    DashBoardTable,
    getPercentageOfTotal,
} from "../../../../backend/src/common/dashboard/dashboardTable";
import { User } from "../../store/store";

import { mathFix } from "../../services/mathServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import Excel from "../../services/excelServices";
import { isOptionalAndWithNoAmount } from "../../../../backend/src/common/dashboard/dashboardTable";
import moment from "moment-timezone";
import _ from "lodash";
import { checkAccessRights } from "../../services/accessRightServices";
import { Component, Vue } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { ref } from "vue";

// Queries to get balances
@Component
export class AccountingSheet extends Vue {
    @Prop({ default: [] }) periods: any;
    @Prop({ default: null }) tags: any;

    @Prop({ default: false }) displayMonthlyData: boolean;
    @Prop({ default: true }) round: boolean;

    updateLoading = false;

    data = [];

    resultPeriods = [];

    dashboardTable: DashBoardTable;
    hasBeenCustomed = false;

    expandedItems = ref(new Set()); // unused

    get accountingPeriodId() {
        if (this.$store.state.accountingPeriod?.selectedAccountingPeriod?.id) {
            return this.$store.state.accountingPeriod.selectedAccountingPeriod.id;
        }
        return (
            this.$store.state.accountingPeriod.accountingPeriods?.[
                this.$store.state.accountingPeriod.accountingPeriods.length - 1
            ]?.id || null
        );
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    getAmountFormatted(table, row, col, pi, month = undefined, subrow = undefined) {
        let amount =
            month === undefined
                ? this.getAmount(table, row, col, pi)
                : this.getMonthlyAmount(table, row, col, pi, month);
        if (subrow && subrow.name) {
            amount =
                month === undefined
                    ? this.getSubRowAmount(table, row, subrow, col, pi)
                    : this.getSubRowMonthlyAmount(table, row, subrow, col, pi, month);
        }
        if (amount === "X") {
            return amount;
        }
        if (amount === null) {
            return "-";
        }
        if (amount === undefined) {
            debugger;
            return "-";
        }
        if (row.displaySign) {
            amount *= row.displaySign;
        }
        if (col.displaySign) {
            amount *= col.displaySign;
        }
        if (row.marginRatio) {
            return (amount * 100).toFixed(2) + " %";
        }
        return newCommonFormatCurrency(amount);
    }

    formatDifference(row) {
        if (!row.difference) return "-";
        let difference = row.difference;
        if (row.displaySign) {
            difference *= row.displaySign;
        }
        return newCommonFormatCurrency(difference);
    }

    formatPercentage(percentage) {
        if (!percentage) return "-";
        return Math.round(percentage * 100) / 100 + " %";
    }

    toggleExpand(item) {
        // unused
        if (this.expandedItems.value.has(item)) {
            this.expandedItems.value.delete(item);
        } else {
            this.expandedItems.value.add(item);
        }
    }

    getQuery() {
        return null;
    }

    computeTableHeaders() {
        for (const table of this.tables) {
            const tmpWidth = (table.columns.length / 12) * 100;
            const firstHeaders = [{ text: "", value: "", align: "start", width: "40%" }];
            const headers = [
                { text: "Postes", value: "name", align: "start", sortable: false, width: "40%" },
            ];
            let pi = 0;
            for (const period of this.resultPeriods) {
                // let columnCount = 0;
                for (const col of table.columns) {
                    if (table.name !== "Actif" || pi === 0 || col.key === "netAmounts") {
                        // pour ne pas afficher brut et net des années précédentes dans le Bilan
                        let text = "";
                        if (period.name) {
                            text = period.name;
                        }
                        if (col.name) {
                            if (text) text += " ";
                            text += col.name;
                        }
                        // if (!period.name) {
                        //     if (text) text += " "
                        //     text += this.periodHeader(period)
                        //     // text += pi
                        // }

                        headers.push({
                            text,
                            value: "",
                            align: "end",
                            sortable: false,
                            width: tmpWidth.toString(),
                        });
                        // columnCount++;
                    }
                }

                if (table.relativePercentage) {
                    headers.push({
                        text: "%",
                        value: "",
                        align: "end",
                        sortable: false,
                        width: tmpWidth.toString(),
                    });
                    // columnCount++;
                }
                firstHeaders.push({
                    text: this.periodHeader(period),
                    value: "",
                    align: "center",
                    width: tmpWidth.toString(),
                });
                pi++;
            }
            if (table.comparison) {
                if (table.comparison.difference) {
                    headers.push({
                        text: "Différence",
                        value: "difference",
                        align: "end",
                        sortable: false,
                        width: tmpWidth.toString(),
                    });
                    firstHeaders.push({
                        text: "",
                        value: "",
                        align: "start",
                        width: tmpWidth.toString(),
                    });
                }
                if (table.comparison.percentage) {
                    headers.push({
                        text: "%",
                        value: "percentage",
                        align: "end",
                        sortable: false,
                        width: tmpWidth.toString(),
                    });
                    firstHeaders.push({
                        text: "",
                        value: "",
                        align: "start",
                        width: tmpWidth.toString(),
                    });
                }
            }
            if (table.extraColumns) {
                for (const column of table.extraColumns) {
                    headers.push({
                        text: column.displayName,
                        value: "",
                        align: "end",
                        sortable: false,
                        width: tmpWidth.toString(),
                    });
                }
                firstHeaders.push({
                    text: "",
                    value: "",
                    align: "end",
                    width: tmpWidth.toString(),
                });
            }
            table.headers = [];
            table.headers.push(firstHeaders);
            table.headers.push(headers);
        }
    }

    getHeaders(table) {
        const tmpWidth = (table.columns.length / 12) * 100;
        const headers = [
            { title: "Postes", value: "name", align: "start", sortable: false, width: "40%" },
        ];
        let pi = 0;
        // debugger
        for (const period of this.resultPeriods) {
            for (const col of table.columns) {
                if (table.name !== "Actif" || pi === 0 || col.key === "netAmounts") {
                    // pour ne pas afficher brut et net des années précédentes dans le Bilan
                    if (pi === 0 && this.displayMonthlyData) {
                        for (const month of this.monthsToDisplay) {
                            headers.push({
                                title: this.monthsInLetter(parseInt(month)),
                                value: "",
                                align: "end",
                                sortable: false,
                                width: tmpWidth.toString(),
                            });
                        }
                        headers.push({
                            title: "Total N",
                            value: "",
                            align: "end",
                            sortable: false,
                            width: tmpWidth.toString(),
                        });
                    } else {
                        let text = "";
                        if (period.type === "budget" || period.type === "freeBudget") {
                            text = "Budget";
                        } else if (period.type === "nMoinsUn") {
                            text = "N-1";
                        } else if (table.columns.length === 1) {
                            text = "N";
                        } else {
                            if (period.name) {
                                text = period.name;
                            }
                            if (col.name) {
                                if (text) text += " ";
                                text += col.name;
                            }
                            if (!period.name) {
                                if (text) text += " ";
                                text += this.periodHeader(period);
                                // text += pi
                            }
                        }
                        headers.push({
                            title: text,
                            value: "",
                            align: "end",
                            sortable: false,
                            width: tmpWidth.toString(),
                        });
                    }
                }
            }
            if (table.getPercentageOfTotal && !this.displayMonthlyData) {
                headers.push({
                    title: "%",
                    value: "",
                    align: "end",
                    sortable: false,
                    width: tmpWidth.toString(),
                });
            }
            if (table.relativePercentage && !this.displayMonthlyData) {
                headers.push({
                    title: "%",
                    value: "",
                    align: "end",
                    sortable: false,
                    width: tmpWidth.toString(),
                });
            }
            pi++;
        }
        if (table.comparison && !this.displayMonthlyData) {
            if (table.comparison.difference) {
                headers.push({
                    title: "Différence",
                    value: "difference",
                    align: "end",
                    sortable: false,
                    width: tmpWidth.toString(),
                });
            }
            if (table.comparison.percentage) {
                headers.push({
                    title: "%",
                    value: "percentage",
                    align: "end",
                    sortable: false,
                    width: tmpWidth.toString(),
                });
            }
        }
        if (table.extraColumns && !this.displayMonthlyData) {
            for (const column of table.extraColumns) {
                headers.push({
                    title: column.displayName,
                    value: "",
                    align: "end",
                    sortable: false,
                    width: tmpWidth.toString(),
                });
            }
        }
        return headers;
    }

    getColumnCount(table) {
        let count = 1 + this.resultPeriods.length * table.columns.length; //deprecated
        if (table.comparison) {
            if (table.comparison.difference) {
                count++;
            }
            if (table.comparison.percentage) {
                count++;
            }
        }
        if (table.relativePercentage) {
            count += this.resultPeriods.length;
        }
        if (table.extraColumns && table.extraColumns.length) {
            count += table.extraColumns.length;
        }
        if (this.displayMonthlyData) {
            count += this.monthsToDisplay.length;
        } else {
            count++;
        }
        return count;
    }

    getRelativePercentage(row, pi) {
        if (row.relativePercentages && pi >= 0 && pi < row.relativePercentages.length) {
            const amount = row.relativePercentages[pi];
            if (amount) {
                return this.formatPercentage(amount);
            }
        }
        return "-";
    }

    getFormatedPercentageOfTotal(row, table, pi, key: string = "netAmounts") {
        return this.formatPercentage(getPercentageOfTotal(row, table, pi));
    }

    getAmount(table, row, col, pi) {
        // const col = table.columns[ci]
        return this.dashboardTable.getAmount(row, col.key, pi);
    }

    getMonthlyAmount(table, row, col, pi, month) {
        // const col = table.columns[ci]
        return this.dashboardTable.getMonthlyAmount(row, col.key, pi, month);
    }

    getSubRowAmount(table, row, subRow, col, pi) {
        // const col = table.columns[ci]
        return this.dashboardTable.getSubRowAmount(row, subRow, col.key, pi);
    }

    getSubRowMonthlyAmount(table, row, subRow, col, pi, month) {
        // const col = table.columns[ci]
        return this.dashboardTable.getSubRowMonthlyAmount(row, subRow, col.key, pi, month);
    }

    get verticalSepratorStyle() {
        return "border-right: dashed 1px grey;";
    }

    addVerticalSeparatorStyle(table, ci, pi) {
        if (ci + 1 === table.columns.length) {
            if (
                pi + 1 < this.resultPeriods.length ||
                table.comparison?.percentage ||
                table.comparison?.difference
            ) {
                return true;
            }
        }
        return false;
    }

    getCellStyle(table, row, ci, pi, mi = undefined, subrow = undefined) {
        let style = "";
        if (this.isCellEditable(row, pi)) {
            style += "cursor: pointer;";
        }
        const col = table.columns[ci];
        const subRowName = subrow ? subrow.name : undefined;
        if (this.dashboardTable.isCustomAmount(row, col.key, pi, mi, subRowName)) {
            style += "color: blue;";
            this.hasBeenCustomed = true;
        }
        if (this.addVerticalSeparatorStyle(table, ci, pi)) {
            style += this.verticalSepratorStyle;
        }
        return style;
    }

    isCellEditable(row, pi) {
        return this.dashboardTable.isCellEditable(row, pi);
    }

    itemRowBackground(item) {
        let style = "";
        if (item.title && item.total) {
            style += "background-color: #eeeeee";
        }
        if (item.subRows?.length) {
            if (style) style += ";";
            style += "cursor: pointer";
        }
        return style;
    }

    colorAmount(item) {
        if (item >= 0) {
            return "font-size: 10pt; color: #5FC9B8";
        }
        return "font-size: 10pt; color: #f76631;";
    }

    colorElement(item) {
        return item.title ? "font-weight:bold; font-size: 10pt;" : "font-size: 10pt;";
    }

    periodHeader(period) {
        if (period.start && period.end) {
            return moment(period.start)
                .utc(false)
                .format("MM[/]YYYY")
                .concat(" - ", moment(period.end).utc(false).format("MM[/]YYYY"));
        } else {
            debugger; // git-ignore
        }
        return "XXX";
    }

    getRowTitleColspan(table, pi) {
        let result = table.columnsToDisplay[pi]?.length ? table.columnsToDisplay[pi].length : 1;
        if (table.getPercentageOfTotal) {
            result++;
        }
        if (table.relativePercentage) {
            result++;
        }
        // if(this.displayMonthlyData) {
        // }
        return result;
    }

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    get companyName() {
        return this.$store.state.selected_company?.name;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "accounting", "dashboard");
        return authorized;
    }

    get title() {
        return "Tableau";
    }

    get className() {
        return "";
    }

    tables = [];

    excelLoading = false;

    get monthsToDisplay() {
        const result = [];
        for (const period of this.periods) {
            if (period.monthly && period === this.periods[0]) {
                const monthDifference = moment(period.end).diff(moment(period.start), "month");
                for (
                    let number = moment(period.start).month();
                    number <= moment(period.start).month() + monthDifference;
                    number++
                ) {
                    result.push(number % 12);
                }
            }
        }
        return result;
    }

    monthsInLetter(month: number) {
        // if changements, change also monthsInLetter function in exportBooklet.ts
        const dicoMonthsInLetter = {
            0: "Jan",
            1: "Fev",
            2: "Mar",
            3: "Avr",
            4: "Mai",
            5: "Jun",
            6: "Jul",
            7: "Aou",
            8: "Sep",
            9: "Oct",
            10: "Nov",
            11: "Dec",
        };
        return dicoMonthsInLetter[month];
    }

    convertToFloat(formatedCurrency: string) {
        let result = formatedCurrency.split(" ").join("");
        result = result.replaceAll(",", ".");
        return parseFloat(result);
    }

    exportExcelInNewSheet(excel: Excel, workbook, style) {
        if (this.tables.length && this.resultPeriods.length) {
            const tables = this.tables;
            const resultPeriods = this.resultPeriods;

            const worksheet = workbook.addWorksheet(this.title, {
                views: [{ showGridLines: false }],
            });
            const firstCol = worksheet.getColumn(1);
            firstCol.width = 30;
            for (const table of tables) {
                if (table.name) {
                    worksheet.addRow([table.name]);
                    worksheet.lastRow.font = { name: "Tahoma", family: 4, size: 16, bold: true };
                    worksheet.lastRow.height = 24;
                }
                // header
                const headers = this.getHeaders(table);

                for (let ci = 2; ci <= headers.length; ci++) {
                    const col = worksheet.getColumn(ci);
                    col.width = 15;
                }

                const execelHeaders = headers.map((h) => h.title);
                worksheet.addRow(execelHeaders);

                excel.applyProperties(
                    worksheet.lastRow,
                    style.normalFont,
                    style.fill,
                    style.height,
                );
                // row
                for (const row of table.rows) {
                    if (row.title && !row.total) {
                        worksheet.addRow([row.title]);
                        excel.applyProperties(
                            worksheet.lastRow,
                            style.titleFont,
                            style.fill,
                            style.height,
                        );
                    } else {
                        const excelRow = [];
                        excelRow.push(row.name || row.title);
                        for (let pi = 0; pi < resultPeriods.length; pi++) {
                            for (const col of table.columns) {
                                const amount = row[col.key][pi];
                                excelRow.push(mathFix(amount, 2));
                            }
                            if (table.relativePercentage) {
                                excelRow.push(this.getRelativePercentage(row, pi));
                            }
                        }
                        if (table.comparison && table.comparison.difference) {
                            excelRow.push(
                                row.difference !== undefined ? mathFix(row.difference, 2) : "",
                            );
                        }
                        if (table.comparison && table.comparison.percentage) {
                            excelRow.push(this.formatPercentage(row.percentage));
                        }
                        worksheet.addRow(excelRow);
                        excel.applyProperties(
                            worksheet.lastRow,
                            row.title ? style.titleFont : style.normalFont,
                            row.title ? style.fill : undefined,
                            undefined,
                        );
                    }
                }
            }
        }
    }

    async exportExcel() {
        // https://github.com/exceljs/exceljs#number-formats
        if (this.tables.length && this.resultPeriods.length) {
            const excel = new Excel();

            const style = excel.getStyle();

            this.excelLoading = true;

            const workbook = excel.createWorkbook();

            this.exportExcelInNewSheet(excel, workbook, style);

            await excel.export(workbook, this.title);
            this.excelLoading = false;
        }
    }

    getExtraColumnsValue(item, columnName) {
        return item.extraColumns && item.extraColumns[columnName]
            ? item.extraColumns[columnName]
            : "";
    }

    updateAmounts() {
        if (this.dashboardTable) {
            this.dashboardTable.build();
        }
    }

    get date() {
        // if not error console
        const result = { start: null, end: null };
        if (this.periods && this.periods.length) {
            result.start = this.periods[0].start;
            result.end = this.periods[0].end;
        }
        return result;
    }

    //
    //
    //
    AABDialog: boolean = false;
    selectedAccountableAccountName: string = ""; // only used for accountableAccountDetailDialog
    selectedAccountableAccountBankAccountName: string = "";
    selectedAccountableAccountThirdPartyCompanyName: string = "";
    selectedAccountableAccountUserId: string = "";

    openAABDetailDialog(selectedAccountableAccountName, selectedAccountableAccountRow = undefined) {
        this.selectedAccountableAccountName = selectedAccountableAccountName;
        this.AABDialog = true;

        this.selectedAccountableAccountBankAccountName =
            selectedAccountableAccountRow.bankAccountName;
        this.selectedAccountableAccountThirdPartyCompanyName =
            selectedAccountableAccountRow.thirdPartyCompanyName;
        this.selectedAccountableAccountUserId = selectedAccountableAccountRow.userId;

        // if(selectedAccountableAccountRow.bankAccountName) {
        //     this.selectedAccountableAccountBankAccountName = selectedAccountableAccountRow.bankAccountName
        // }
        // if(selectedAccountableAccountRow.thirdPartyCompanyName) {  // ['401', '411'].some( e => selectedAccountableAccountName.startsWith(e))
        //     this.selectedAccountableAccountThirdPartyCompanyName = selectedAccountableAccountRow.thirdPartyCompanyName
        // }
        // if(selectedAccountableAccountRow.userId) {  // '467'
        //     this.selectedAccountableAccountUserId = selectedAccountableAccountRow.userId
        // }
    }

    get accountableAccountInfo() {
        return {
            name: this.selectedAccountableAccountName,
            bankAccountName: this.selectedAccountableAccountBankAccountName,
            thirdPartyCompanyName: this.selectedAccountableAccountThirdPartyCompanyName,
            userId: this.selectedAccountableAccountUserId,
        };
    }

    @Watch("AABDialog")
    resetSelectedAccountableAccountVariables() {
        if (this.AABDialog === false) {
            this.selectedAccountableAccountBankAccountName = undefined;
            this.selectedAccountableAccountThirdPartyCompanyName = undefined;
            this.selectedAccountableAccountUserId = undefined;
        }
    }

    withAmountOrNotOptional(item) {
        return !isOptionalAndWithNoAmount(item);
    }

    //
    //
    //

    setColumnsToDisplay(output, table, periods) {
        const columnsToDisplay = [];
        for (const pi in periods) {
            columnsToDisplay.push([]);
            // let found = false
            for (const ci in table.columns) {
                if (
                    output.tables.length === 1 ||
                    pi === "0" ||
                    table.columns[ci].key === "netAmounts"
                ) {
                    columnsToDisplay[pi].push(table.columns[ci]);
                    // found = true
                    // break;
                }
            }
            // if (!found) {
            //     for(const ci in table.columns) {
            //         if(output.tables.length === 1 || pi === '0' ) {
            //             columnsToDisplay[pi].push(table.columns[0])
            //             found = true
            //             break;
            //         }
            //     }
            // }
        }
        table.columnsToDisplay = columnsToDisplay;
    }
}
